import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'

import Fonts from '../../Icons/aboutus/fonts.svg'
import Solutions from '../../Icons/aboutus/solutions.svg'
import Unique from '../../Icons/aboutus/unique.svg'

export default function Marketing() {
    const settings = {
        arrows: false,
        dots: true,
        className: 'align-items-center',
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        appendDots: (dots) => {
            return <ul style={{ margin: '0px' }}> {dots}</ul>
        },
        customPaging: () => <span className="slick-dot"></span>,
    }

    return (
        <div className="rounded-tl-[75px] rounded-tr-[75px] bg-gradient-to-b from-[#fdedce] to-transparent md:mt-[100px]">
            <div className="container mx-auto md:my-16 mb-16">
                <h3 className="md:text-[45px] md:leading-[52.83px] leading-[35.22px] text-3xl font-bold text-center md:pt-[6rem] md:pb-0 pt-[70px] pb-[30px] md:px-0 px-[33px]">
                    <span>The </span>
                    <span className="olm-gradient-text">
                        most effective direct mail marketing
                    </span>
                    <span> for </span>
                    <br className="md:block hidden" />
                    <span>real estate professionals on the market.</span>
                </h3>
                <div className="md:space-y-0 md:space-x-4 hidden lg:flex lg:flex-row flex-col items-center space-y-5 px-10 md:pt-[4rem] md:pb-20">
                    <div className="md:w-1/3 text-center bg-white rounded-[20px] shadow-[0_4px_20px_rgba(242,130,48,0.2)] border border-orange-500 text-center flex flex-col items-center px-[23px] pt-[61px] max-w-[378px] h-[489px]">
                        <Unique />
                        <h3 className="text-[25px] leading-[30px] font-semibold text-center md:pt-10">
                            <span>Unique REI </span>
                            <br />
                            <span>Direct Mailers</span>
                        </h3>
                        <p className="text-[18px] leading-[25px] font-medium text-center md:pb-0 pb-[70px] pt-[10px]">
                            Our real estate investment direct mail marketing
                            products really stand out! You can custom envelopes
                            and use specialty stamps for a branded look.
                        </p>
                    </div>
                    <div className="md:w-1/3 text-center bg-white rounded-[20px] shadow-[0_4px_20px_rgba(242,130,48,0.2)] border border-orange-500 text-center flex flex-col items-center px-[23px] pt-[61px] max-w-[378px] h-[489px]">
                        <Fonts />
                        <h3 className="text-[25px] leading-[30px] font-semibold text-center md:pt-[51px]">
                            <span>Eye Catching Fonts</span>
                        </h3>
                        <p className="text-[18px] leading-[25px] font-medium text-center md:pb-0 pb-[70px] pt-[33.5px]">
                            We’ve researched which formats and typefaces deliver
                            the highest real estate direct mail marketing
                            response rates.
                        </p>
                    </div>
                    <div className="md:w-1/3 text-center bg-white rounded-[20px] shadow-[0_4px_20px_rgba(242,130,48,0.2)] border border-orange-500 text-center flex flex-col items-center px-[20px] pt-[61px] max-w-[378px] h-[489px]">
                        <Solutions />
                        <h3 className="text-[25px] leading-[30px] font-semibold text-center md:pt-10">
                            <span>Alternative real</span>
                            <br />
                            <span>estate investment</span>
                            <br />
                            <span>marketing solutions</span>
                        </h3>
                        <p className="text-[18px] leading-[25px] font-medium text-center md:pb-0 pb-[70px] pt-[10px]">
                            We offer other direct to seller tactics designed to
                            help you stand out. These services include Ringless
                            Voicemail, IP Marketing and Batch Skip Tracing.
                        </p>
                    </div>
                </div>
                <div className="mx-[2rem] block lg:hidden">
                    <Slider {...settings}>
                        <div className="px-3 py-4">
                            <div className="text-center bg-white rounded-[20px] border border-orange-500 shadow-[0_4px_20px_rgba(242,130,48,0.2)] text-center flex flex-col items-center px-[23px] pt-[55px] h-[489px]">
                                <div className="text-center">
                                    <img
                                        src="/assets/about-us/marketing/unique.webp"
                                        alt="Marketing"
                                        width="80px"
                                        height="80px"
                                    />
                                </div>
                                <h3 className="text-[25px] leading-[30px] font-semibold text-center md:pt-10 pt-[35px]">
                                    <span>Unique REI </span>
                                    <br />
                                    <span>Direct Mailers</span>
                                </h3>
                                <p className="text-[18px] leading-[1.6rem] font-medium text-center md:pb-0 pb-[70px] pt-[15px] max-w-[86%]">
                                    Our real estate investment direct mail
                                    marketing products really stand out! You can
                                    custom envelopes and use specialty stamps
                                    for a branded look.
                                </p>
                            </div>
                        </div>
                        <div className="px-3 py-4">
                            <div className="text-center bg-white rounded-[20px] border border-orange-500 shadow-[0_4px_20px_rgba(242,130,48,0.2)] text-center flex flex-col items-center px-[23px] pt-[55px] h-[489px]">
                                <div className="text-center">
                                    <img
                                        src="/assets/about-us/marketing/fonts.webp"
                                        alt="Marketing"
                                        width="80px"
                                        height="80px"
                                    />
                                </div>
                                <h3 className="text-[25px] leading-[30px] font-semibold text-center pt-[35px]">
                                    <span>Eye Catching Fonts</span>
                                </h3>
                                <p className="text-[18px] leading-[1.6rem] font-medium text-center md:pb-0 pb-[70px] pt-[41px]">
                                    We’ve researched which formats and typefaces
                                    deliver the highest real estate direct mail
                                    marketing response rates.
                                </p>
                            </div>
                        </div>
                        <div className="px-3 py-4">
                            <div className="text-center bg-white rounded-[20px] border border-orange-500 shadow-[0_4px_20px_rgba(242,130,48,0.2)] text-center flex flex-col items-center px-[23px] pt-[55px] h-[489px]">
                                <div className="text-center">
                                    <img
                                        src="/assets/about-us/marketing/solutions.webp"
                                        alt="Marketing"
                                        width="80px"
                                        height="80px"
                                    />
                                </div>
                                <h3 className="text-[25px] leading-[30px] font-semibold text-center pt-[35px]">
                                    <span>Alternative real</span>
                                    <br />
                                    <span>estate investment</span>
                                    <br />
                                    <span>marketing solutions</span>
                                </h3>
                                <p className="text-[18px] leading-[1.6rem] font-medium text-center md:pb-0 pb-[70px] pt-[5px]">
                                    We offer other direct to seller tactics
                                    designed to help you stand out. These
                                    services include Ringless Voicemail, IP
                                    Marketing and Batch Skip Tracing.
                                </p>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </div>
    )
}
